import { ReadableDifference, ShowRunOutWarningClass } from '@utils/general'
import { Card, Col, Row } from 'antd'
import React from 'react'

export function StorePopover({ store, hasAlerts, rundownToggled }) {
  const popoverTitle = (
    <StorePopoverTitle title={store.store_number} name={store.name} city={store.city} hasAlerts={hasAlerts} />
  )

  return (
    <Card size='small' className={`store-popover-card ${hasAlerts ? 'store-has-alert' : ''}`} title={popoverTitle}>
      {store.tanks.map((value, i) => (
        <TankRow key={i} rundownToggled={rundownToggled} {...value} />
      ))}
    </Card>
  )
}

function TankRow({ product, run_out_date, run_out_date_with_drops, rundownToggled }) {
  const displayRunOutDate = rundownToggled ? run_out_date_with_drops : run_out_date

  return (
    <Row className='tank-row-popover'>
      <Col className='tank-row-product' span={14} style={{ fontWeight: 600 }}>
        {product}
      </Col>
      <Col className={ShowRunOutWarningClass(displayRunOutDate)} span={10} style={{ textAlign: 'right' }}>
        {ReadableDifference(displayRunOutDate, undefined, true)}
      </Col>
    </Row>
  )
}

function StorePopoverTitle({ title, name, city, hasAlerts }) {
  return (
    <div>
      <div className='flex-div' style={{ justifyContent: 'space-between' }}>
        <div style={{ fontWeight: 'bold' }}>{title}</div>
        <div>{name && name.toUpperCase()}</div>
      </div>
      <div className='name-city'>{city}</div>
    </div>
  )
}
